// @flow

import { takeLatest, takeEvery, put, call, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import {
  FETCH_MESSAGES,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_FAILURE,
  FETCH_NEW_MESSAGES_SUCCESS,
  FETCH_PREVIOUS_MESSAGES,
  FETCH_PREVIOUS_MESSAGES_SUCCESS,
  SEND_MESSAGE,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAILURE,
  FETCH_PREVIOUS_MESSAGES_PENDING,
  FETCH_PREVIOUS_MESSAGES_FAILURE,
} from '../actions/messages';
import { getMessages, getCurrentThread } from '../reducers/messages';
import { getThreads, getThread } from '../reducers/threads';
import * as MessagesApi from '../api/messages';
import { normalize } from 'normalizr';
import * as Schema from '../api/schema';

const POLL_DELAY = 5000;

function* fetchMessages({ thread }) {
  try {
    const { status, total, messages } = yield call(MessagesApi.fetchMessages, {
      thread,
    });

    yield put({
      type: FETCH_MESSAGES_SUCCESS,
      response: normalize(messages, Schema.messages),
      thread,
      status,
      total,
    });
  } catch (error) {
    yield put({
      type: FETCH_MESSAGES_FAILURE,
      error,
    });
  }
}

function* fetchPreviousMessages({ thread, scrollHeight }) {
  const existingMessages = yield select(getMessages);

  yield put({
    type: FETCH_PREVIOUS_MESSAGES_PENDING,
  });

  const firstIndex = existingMessages.map(m => m.index).min();

  try {
    const { status, total, messages } = yield call(MessagesApi.fetchMessages, {
      thread,
      endIndex: firstIndex,
    });

    yield put({
      type: FETCH_PREVIOUS_MESSAGES_SUCCESS,
      response: normalize(messages, Schema.messages),
      thread,
      status,
      total,
      scrollPosition: scrollHeight,
    });
  } catch (error) {
    yield put({
      type: FETCH_PREVIOUS_MESSAGES_FAILURE,
      error,
    });
  }
}

function* sendMessage({ thread, content, files }) {
  try {
    const { index } = yield call(MessagesApi.sendMessage, {
      thread,
      content,
      files,
    });

    // Fetching messages
    const { status, total, messages } = yield call(MessagesApi.fetchMessages, {
      thread,
      endIndex: index + 1,
    });

    yield put({
      type: SEND_MESSAGE_SUCCESS,
    });

    yield put({
      type: FETCH_MESSAGES_SUCCESS,
      response: normalize(messages, Schema.messages),
      thread,
      status,
      total,
    });
  } catch (error) {
    yield put({
      type: SEND_MESSAGE_FAILURE,
      error,
    });
  }
}

function* pollMessages() {
  function* getThreadMessage(thread) {
    try {
      const lastIndex = thread.lastMessage ? thread.lastMessage.index : 0;
      const { total, messages } = yield call(MessagesApi.fetchMessages, {
        thread: thread.id,
        startIndex: lastIndex,
      });

      if (messages.length > 0) {
        yield put({
          type: FETCH_NEW_MESSAGES_SUCCESS,
          response: normalize(messages, Schema.messages),
          thread: thread.id,
          total,
          diff: messages.length,
          lastMessage: Schema.enrichMessage(messages[messages.length - 1]),
        });
      }
    } catch (error) {
      // Ignoring
    }
  }

  while (true) {
    yield call(delay, POLL_DELAY);
    const threadId = yield select(getCurrentThread);
    if (threadId != null) {
      const thread = yield select(getThread, threadId);
      yield call(getThreadMessage, thread);
    } else {
      const threads = yield select(getThreads);
      const effects = threads.map(t => call(getThreadMessage, t)).toArray();
      yield [...effects];
    }
  }
}

export default function* root() {
  yield [
    takeLatest(FETCH_MESSAGES, fetchMessages),
    takeEvery(FETCH_PREVIOUS_MESSAGES, fetchPreviousMessages),
    takeEvery(SEND_MESSAGE, sendMessage),
    call(pollMessages),
  ];
}



// WEBPACK FOOTER //
// ./src/modules/messaging/sagas/messages.js